"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("../../Theme"));
/* no-restricted-imports */


var Dot = _styledComponents.default.div.withConfig({
  displayName: "ImageIndicator__Dot",
  componentId: "sc-1y2ddka-0"
})(["width:", ";height:", ";background-color:", ";border-radius:", ";cursor:pointer;margin:", ";"], function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active ? theme.space.normal : theme.space.xxtiny;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xxtiny;
}, function (_ref3) {
  var active = _ref3.active,
      theme = _ref3.theme;
  return active ? theme.backgroundColor.default : theme.backgroundColor.gray;
}, function (_ref4) {
  var active = _ref4.active,
      theme = _ref4.theme;
  return active ? theme.space.small : '50%';
}, function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.none, " ").concat(theme.space.mini);
});

var ImageIndicator = function ImageIndicator(_ref6) {
  var onClick = _ref6.onClick,
      active = _ref6.active,
      theme = _ref6.theme;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement("li", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react.default.createElement(Dot, {
    active: active,
    onClick: onClick
  })));
};

ImageIndicator.propTypes = {
  onClick: _propTypes.func,
  active: _propTypes.bool,
  theme: _propTypes.string
};
ImageIndicator.defaultProps = {
  onClick: function onClick() {},
  active: true,
  theme: ''
};
var _default = ImageIndicator;
exports.default = _default;